import { render, staticRenderFns } from "./wl-list.vue?vue&type=template&id=5bc9d9a8&scoped=true&lang=pug"
import script from "./wl-list.js?vue&type=script&lang=js&external"
export * from "./wl-list.js?vue&type=script&lang=js&external"
import style0 from "./wl-list.styl?vue&type=style&index=0&id=5bc9d9a8&lang=stylus&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc9d9a8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\G\\YT\\mes-project-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5bc9d9a8')) {
      api.createRecord('5bc9d9a8', component.options)
    } else {
      api.reload('5bc9d9a8', component.options)
    }
    module.hot.accept("./wl-list.vue?vue&type=template&id=5bc9d9a8&scoped=true&lang=pug", function () {
      api.rerender('5bc9d9a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/wl-component-gallery/wl-list/wl-list.vue"
export default component.exports